import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-membership-disclaimer',
  imports: [TranslateModule],
  templateUrl: './membership-disclaimer.component.html',
  styleUrl: './membership-disclaimer.component.scss'
})
export class MembershipDisclaimerComponent {
  @Output() onSubmit = new EventEmitter<boolean>();

  close() {
    this.onSubmit.emit(false);
  }

  agree() {
    this.onSubmit.emit(true);
  }
}
